module.exports = __webpack_public_path__ + "static/media/truck-pickup.c6d06f8b.svg";